import GenericService from '@/api/generic.service';

const state = () => ({
  clients: { data: [] },
  users: { data: [] },
  warehouses: { data: [] },
});
const getters = {
	GetClients: (state) => {
		return state.clients;
	},
	GetWarehouses: (state) => state.warehouses,
	GetUsers: (state) => state.users,
	GetClientUsers: (state) => {
		let usersList = { ...state.users };
		let clientList = [];
		usersList.data.forEach((user) => {
			if (user.clientName) {
				clientList.push(user);
			}
		});
		usersList.data = clientList;
		return usersList;
	},
	GetDistroUsers: (state) => {
		let usersList = { ...state.users };
		let distroList = [];
		usersList.data.forEach((user) => {
			if (user.distributionCentreName) {
				distroList.push(user);
			}
		});
		usersList.data = distroList;
		return usersList;
	},
	GetWarehouseUsers: (state) => {
		let usersList = { ...state.users };
		let warehouseList = [];
		usersList.data.forEach((user) => {
			if (user.warehouseName) {
				warehouseList.push(user);
			}
		});
		usersList.data = warehouseList;
		return usersList;
	},
	GetCustomerUsers: (state) => {
		let usersList = { ...state.users };
		let warehouseList = [];
		usersList.data.forEach((user) => {
			if (user.retailCentreName) {
				warehouseList.push(user);
			}
		});
		usersList.data = warehouseList;
		return usersList;
	},
};
const mutations = {
  SET_CLIENTS_STATE: (state, clientsData) => {
    state.clients = clientsData;
  },
  SET_USERS_DETAILS: (state, usersData) => {
    state.users = usersData;
  },
  SET_WAREHOUSE_STATE: (state, newData) => {
    state.warehouses = newData;
  },
};
const actions = {
	/**
	 * fetch all available clients
	 * @param   {Object}    context   vuejs context object commit|dispact
	 * @return  {Object}    sets roles state with new roles
	 */
	FetchClients: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const response = await GenericService.clients(authToken, payload);
			context.commit('SET_CLIENTS_STATE', response.data);
		} catch (error) {
			return error;
		}
	},
	/**
	 * fetch all available USERS
	 * @param   {Object}    context   vuejs context object commit|dispact
	 * @return  {Object}    sets roles state with new roles
	 */
	FetchUsers: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const response = await GenericService.users(authToken, payload);
			context.commit('SET_USERS_DETAILS', response.data);
		} catch (error) {
			return error;
		}
	},
	/**
	 * fetch all available warehouses
	 * @param   {Object}    context   vuejs context object commit|dispact
	 * @return  {Object}    sets roles state with new roles
	 */
	FetchWarehouses: async (context, payload) => {
		const { authToken } = context.rootState.auth;
		try {
			const response = await GenericService.warehouses(authToken, payload);
			context.commit('SET_WAREHOUSE_STATE', response.data);
		} catch (error) {
			return error;
		}
	},
	
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
